import apis from "@/apis/bom";
import requirementApis from "@/apis/requirement";

import useDataDetail from "@/hooks/useDataDetail";
import { Bom, BomItem } from "@/types/bom";
import { SaleItemState, SaleOrderItemState } from "@/types/sales";
import { multi, plus, divided } from "@/utils/calc";
import { App, Flex, Form, Input, Modal, ModalProps, notification, Result, Select, Spin, Steps, Tabs, Typography } from "antd";
import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { RequirementAddItemUseRepl, RequirementConfirmShowEnum, RequirementConfirmTypeEnum, RequirementTemplate } from "@/types/requirement";
import "handsontable/dist/handsontable.full.min.css";
import MatchBom from "./components/MatchBom";
import { RequirementColumn } from "../../type";
import EditRequirement from "../../components/EditRequirement";
import RequirementForm, {
  RequirementFieldType,
} from "../../components/RequirementForm";
import CreateHeader from "./components/CreateHeader";
import CreateFooter from "./components/CreateFooter";
import { DataWrap, ModalWrap } from "./style";
import MatchStock from "./components/MatchStock";
import PreOutData from "./components/PreOutData";
import SText from "@/styles/SText";
import ProdInput, { ProdInputRef } from "../Detail/components/ProdInput";
import { PageId } from "@/types/page";
import { Product } from "@/types/product";
import getFileBuffer from "@/utils/file/getFileBuffer";
import { makeBomData, parseBomFileBuffer } from "./utils";
import { productAdd, productList } from "@/apis/product";
import ExportProgressModal from "@/components/ExportProgressModal";
import STableLayout from "@/styles/STableLayout";
import { ColumnsType } from "antd/es/table";
import { AnyObject } from "antd/es/_util/type";
import { ProductInfoStateEnum } from "@/types/productInfo";
import { DEFAULT_CREATE_REQUIREMENT_PRE_OUT_LOCATION_TYPES } from "./utils/preOutLocationTypes";
import SelectLocationType from "@/components/Selector/SelectLocationType";
import { OrderAddV2 } from "@/types/inventoryV2";
import ReTryPreOut from "../../components/ReTryPreOut";

interface FinanceRequireProps extends ModalProps {
  saleOrder: SaleOrderItemState;
  item: SaleItemState;
  handleAdd: () => void;
  handleCancel: () => void
}

type DataType = "B" | "T" | "X";
export interface MatchedRequirementColumn extends RequirementColumn {
  stockNum: number;  //库存数量
  stockPreOut: number;  //库存预出库数量
  useNum: number;  //可用库存数量
  purCount: number;  //最终的amount[需采购]
  preOutNum: number;  //预出库数量
  preIn: number;  //预出库数量
  matchKey: string;
  allocated: number;//已用库存数量
  useFactoryCount: number;
  factoryCount: number;  //产线库存数量
  factoryAllocated: number;  //产线已分配数量
}

const CreateRequirement: FC<FinanceRequireProps> = ({
  saleOrder,
  item,
  handleAdd,
  handleCancel,
  ...modalProps
}) => {
  const { t } = useTranslation();
  const prodInputRef = useRef<ProdInputRef>(null);
  const {
    loading: deLoading,
    fetchDetail,
    detail,
  } = useDataDetail({ api: apis.fetch });
  const { modal } = App.useApp();

  const [bomSubs, setBomSubs] = useState<Array<RequirementColumn>>([]);
  const [templeData, setTempleData] = useState<Array<RequirementColumn>>([]);
  const [templeRes, setTempleRes] = useState<RequirementTemplate>([]);
  const [bomData, setBomData] = useState<Array<RequirementColumn>>([]);
  const [xlsData, setXlsData] = useState<Array<RequirementColumn>>([]);
  const [dataType, setDataType] = useState<DataType>("T");
  const [purchaseProducts, setPurchaseProducts] = useState<Array<RequirementColumn>>([]);  //修改数量
  const [current, setCurrent] = useState<number>(0);
  const [matchedProducts, setMatchedProducts] = useState<Array<MatchedRequirementColumn>>([]);     //匹配库存
  const [confirmProducts, setConfirmProducts] = useState<Array<RequirementColumn>>([]);   //确认数据
  const [number, setNumber] = useState<string>(""); // 需求清单的备注
  const [requirementCount, setRequirementCount] = useState<number>(
    Number(plus((item?.quantity || 0).toString(), (item?.bquantity || 0).toString()))
  ); // 订单数量
  const [isTemp, setIsTemp] = useState<boolean>(false); // 是否是存储的模板
  const [formData, setFormData] = useState<RequirementFieldType>();

  const [bomLoading, setBomLoading] = useState<boolean>(false); // 需求清单的备注
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState<number>(600);
  const [disNext, setDisNext] = useState<boolean>(false);
  const [matchStock, setMatchStock] = useState<boolean>(false);
  const [matchFactory, setMatchFactory] = useState<boolean>(false);
  const [isMerge, setIsMerge] = useState<boolean>(false);
  const [desc, setDesc] = useState<string>('');
  const [preOutLocationTypes, setPreOutLocationTypes] = useState<number[]>(
    DEFAULT_CREATE_REQUIREMENT_PRE_OUT_LOCATION_TYPES,
  );

  const [initBomData, setInitBomData] = useState<Array<RequirementColumn>>([]);
  const [addNewPros, setAddNewPros] = useState<Array<RequirementColumn>>([]);
  const [addProsLoaidng, setAddProsLoaidng] = useState<boolean>(false);
  const [addProsProgress, setAddProsProgress] = useState<number>(0);
  const [locTypes, setLocTypes] = useState<number[]>([1]);
  const [failItems, setFailItems] = useState<MatchedRequirementColumn[]>([]);
  const [failAdd, setFailAdd] = useState<OrderAddV2 | null>(null);

  useEffect(() => {
    if (scrollContainerRef.current) setContainerHeight(scrollContainerRef.current.getBoundingClientRect().height)
  }, [scrollContainerRef.current]);

  useEffect(() => {
    if (saleOrder.bomFileId || saleOrder.productId) initData(!!saleOrder.bomFileId);
    else initSwap();
  }, [saleOrder]);

  const renderPreOutLocationTypeSelect = () => (
    <Form.Item
      required
      label={t('requirement.matchLocType')}
      style={{ marginBottom: 0, flex: 1, minWidth: 0 }}
    >
      <SelectLocationType
        mode="multiple"
        style={{ flex: 1 }}
        value={locTypes.length > 0 ? locTypes : preOutLocationTypes}
        onChange={locTypes.length > 0 ? undefined : setPreOutLocationTypes}
        allowClear maxTagCount={2}
      />
    </Form.Item>
  );

  const confirmTableTabs = <Tabs
    type="card" items={[
      {
        label: <SText text={t('layout.requirementList')} />,
        key: 'requirementList',
        children: <PreOutData setMatchedProducts={setMatchedProducts}
          confirmProducts={matchedProducts.filter(item => item.useAmount > 0)}
          scrollHeight={containerHeight - 60}
          confirmed
        />
      },
      {
        label: <SText text={t('requirement.preOutInventory')} />,
        key: 'preOutInventory',
        disabled: matchStock,
        children: <PreOutData
          confirmProducts={matchedProducts.filter(i => i.preOutNum && i.preOutNum > 0 && i.product.preReady === 0)}
          scrollHeight={containerHeight - 150}
        />
      },

    ]}
  />

  const steps = [
    {
      title: t("requirement.matchBom"),
      key: "1",
      content: <MatchBom bomSubs={bomSubs} setBomSubs={setBomSubs} scrollHeight={containerHeight - 20}
        toolbarExtra={
          <Flex gap={4} align="center" style={{ flex: 1, minWidth: 0 }}>
            <SText text={t('requirement.dataTypeTip') + ": "} style={{ width: "auto", marginRight: 6, flexShrink: 0, color: bomSubs.length === 0 ? "red" : "unset" }} />
            <Tabs className={`source-tabs source-tabs-${dataType}`}
              activeKey={dataType} onChange={val => setDataType(val as DataType)} type="line" items={[
                { label: t('requirement.xlsData'), key: "X" },
                { label: t('requirement.templeData'), key: "T" },
                { label: t('requirement.bomDatax'), key: "B" },
              ]} style={{ flex: 1, minWidth: 0 }} />
          </Flex>
        }
      />,
    },
    {
      title: t("requirement.editQuantity"),
      key: "2",
      content: (
        <EditRequirement isMerge={isMerge} setIsMerge={setIsMerge}
          purchaseProducts={purchaseProducts}
          setPurchaseProducts={setPurchaseProducts}
          requireCount={requirementCount}
          scrollHeight={containerHeight}
          matchStock={matchStock}
          setMatchStock={setMatchStock}
          matchFactory={matchFactory}
          setMatchFactory={setMatchFactory}
          locTypes={locTypes}
          setLocTypes={setLocTypes}
        />
      ),
    },
    {
      title: t("requirement.matchInventory"),
      key: "3",
      content: (
        <MatchStock
          isMerge={isMerge}
          purchaseProducts={purchaseProducts}
          matchedProducts={matchedProducts}
          setMatchedProducts={setMatchedProducts}
          requireCount={requirementCount}
          scrollHeight={containerHeight}
          setDisNext={setDisNext}
          matchFactory={matchFactory}
          locTypes={locTypes}
        />
      )
    },
    {
      title: t("requirement.preOut"),
      key: "4",
      content: (
        <DataWrap>
          <PreOutData
            toolbarExtra={renderPreOutLocationTypeSelect()}
            confirmProducts={matchedProducts.filter(i => i.preOutNum && i.preOutNum > 0 && i.product.preReady === 0)}
            scrollHeight={containerHeight}
          />
        </DataWrap>
      )
    },
    {
      title: t("bom.confirmAdd"),
      key: "6",
      content: (<DataWrap>
        <RequirementForm onValuesChange={(d, data) => {
          setFormData(data)
        }} />
        {
          formData?.steps?.find(s => s.type === RequirementConfirmTypeEnum.PROD && s.show === RequirementConfirmShowEnum.HIDDEN)
          && <div style={{ marginTop: "-10px", marginBottom: "10px" }}>
            <ProdInput ref={prodInputRef} pageId={PageId.MC_NOT_PASS} detail={undefined} />
          </div>
        }
        {
          matchedProducts.filter(i => i.preOutNum && i.preOutNum > 0 && i.product.preReady === 0).length > 0 && <Form.Item label={t('requirement.preOutDesc')} style={{ marginBottom: 2, marginTop: -18 }}>
            <Input.TextArea size="small" autoSize={{ minRows: 1, maxRows: 1 }} maxLength={200} value={desc} onChange={e => setDesc(e.target.value)} />
          </Form.Item>
        }
        <div className="data-container">
          {confirmTableTabs}
        </div>
      </DataWrap>),
    },
    {
      title: t("requirement.done"),
      key: "7",
      content: (
        (!!failItems.length && !!failAdd) ? (
          <ReTryPreOut failAdd={failAdd} failItems={failItems}
            number={number} scrollHeight={containerHeight}
            onOk={() => { setFailItems([]); setFailAdd(null) }}
            locTypes={locTypes} preOutLocationTypes={preOutLocationTypes}
          />
        )
          : (<Result
            status="success"
            title={t("requirement.doneSuccess")}
            subTitle={t("requirement.doneSuccessTip", { number })}
          />)
      ),
    },
  ];

  const handleTemplate = (temple: RequirementTemplate) => {
    setPurchaseProducts(
      temple.map((bsI) => ({
        product: bsI.product,
        useAmount: Math.ceil(
          Number(
            plus(
              multi(bsI.useAmount.toString(), item.quantity.toString()),
              bsI.extCount
            )
          )
        ),
        reqs: [],
        useRepl: RequirementAddItemUseRepl.NOT_USE,
        bomItemId: "",
        bomReplId: "",
        bomRequireCount: Math.ceil(Number(
          multi(bsI.useAmount.toString(), item.quantity.toString())
        )),
        extCount: Number(bsI.extCount),
        baseQuantity: Number(bsI.baseCount),
        attritionRate: Number(bsI.attritionRate),
        useQuantity: Number(bsI.useAmount),
      }))
    );
  };

  useEffect(() => {
    if (!bomLoading && current === 0) {
      setFailAdd(null);
      setFailItems([]);
      if (dataType === "B") setBomSubs([...bomData]);
      if (dataType === "T") {
        setBomSubs([...templeData]);
        setIsTemp(true);
        handleTemplate(templeRes);
      }
      if (dataType === "X") setBomSubs([...xlsData]);
    }
  }, [dataType, setBomSubs, current]);

  const initSwap = () => {
    setBomLoading(true);
    setTimeout(() => {
      setPurchaseProducts(saleOrder.items.map(orderItem => {
        return {
          product: orderItem.product!,
          useAmount: 0,
          reqs: [],
          useRepl: RequirementAddItemUseRepl.NOT_USE,
          bomItemId: "",
          bomReplId: "",
          bomRequireCount: 0,
          extCount: Math.ceil(Number(plus((orderItem.quantity || 0) + '', (orderItem.bquantity || 0) + ''))),
          attritionRate: 0,
          baseQuantity: 0,
          useQuantity: 0,
        }
      }));
      setCurrent(current + 1);
      setBomLoading(false);
    }, 1000);
  };

  const getFinanceRequireData = (bomItem: BomItem): RequirementColumn[] => {
    let reqs: Array<RequirementColumn> = [];
    // 如果不是 'formal' 类型，直接返回空数组
    if (bomItem.type !== "formal") return [];

    // 如果有子项，递归调用并合并结果
    if (bomItem.subs.filter((item) => item.type === "formal").length > 0) {
      return bomItem.subs.flatMap((subItem) => getFinanceRequireData(subItem));
    }

    const getRealQuantity = (item: BomItem, saleItem: SaleItemState) => {
      const rate = divided(item.attritionRate.toString(), "100");
      const itemRate = multi(item.useQuantity, rate);
      const itemQuantity = plus(item.useQuantity, itemRate);
      const allQuantity = multi(
        itemQuantity,
        saleItem.quantity.toString()
      );

      return Math.ceil(Number(allQuantity));
    };

    reqs = bomItem.subs
      .filter((item) => item.type === "req")
      .map((bI) => ({
        product: bI.product,
        useAmount: getRealQuantity(bI, item),
        reqs: [],
        useRepl: RequirementAddItemUseRepl.USED,
        bomItemId: bomItem.id,
        bomReplId: bI.id,
        bomRequireCount: getRealQuantity(bI, item),
        extCount: 0,
        attritionRate: Number(bI.attritionRate),
        baseQuantity: Number(bI.baseUnit),
        useQuantity: Number(bI.useQuantity),
      }));

    // 如果没有子项，返回当前项的转换结果
    return [
      {
        product: bomItem.product,
        useAmount: getRealQuantity(bomItem, item),
        reqs,
        useRepl: RequirementAddItemUseRepl.NOT_USE,
        bomItemId: bomItem.id,
        bomReplId: "",
        attritionRate: Number(bomItem.attritionRate),
        baseQuantity: Number(bomItem.baseUnit),
        bomRequireCount: getRealQuantity(bomItem, item),
        extCount: 0,
        useQuantity: Number(bomItem.useQuantity),
        bomProcess: bomItem.process || undefined
      },
    ];
  };
  const initData = async (isX?: boolean) => {
    setBomLoading(true);
    let temple: RequirementTemplate | null = null;
    try {
      temple = await requirementApis.tempFetch(item.productId);
      if (!!temple?.length) {
        setTempleRes([...temple]);
        setTempleData(temple.map(data => ({
          ...data,
          reqs: [],
          bomItemId: data.productId,
          useRepl: RequirementAddItemUseRepl.NOT_USE,
          bomReplId: data.productId,
          bomRequireCount: 0,
          baseQuantity: Number(data.baseCount) || 0,
          useQuantity: Number(data.useAmount) || 0,
          attritionRate: Number(data.attritionRate) || 0,
          extCount: Number(data.extCount) || 0,
          beReplaced: false,
          replaceParentId: undefined
        })));
      };
    } catch (error) { }
    let bom: Bom | null = null;
    try {
      bom = await fetchDetail(item.productId);
      if (bom?.items) {
        let bomRes: RequirementColumn[] = bom.items.flatMap((bI) =>
          getFinanceRequireData(bI)
        );
        setBomData(bomRes);
      }
    } catch (error) { }
    if (saleOrder?.bomFileId) {
      await parseBomData(saleOrder.bomFileId);
    };
    if (isX) setDataType("X")
    else if (!!temple?.length) setDataType("T")
    else if (!!bom?.items) setDataType("B");
    if (!isX && !!!temple?.length && !!!bom?.items) notification.error({ message: t('bom.bomNull'), description: t('bom.bomNullTip') })
    setBomLoading(false);
  };

  const parseBomData = async (bomFileId: string) => {
    setBomLoading(true)
    try {
      let res = await getFileBuffer(bomFileId);
      let resInitData = parseBomFileBuffer(res, item.quantity || 0).list;
      let codes = resInitData.map(a => a.product.code);
      if (!!!codes?.length) {
        setBomLoading(false);
        return notification.error({ message: t('requirement.dataTypeErr'), description: t('requirement.dataTypeErrTip') });
      }

      const productListRes = await productList({ params: { strs: codes } });
      const productListMap: Record<string, Product> = {};
      productListRes.body.forEach(p => {
        productListMap[p.code] = { ...p }
      });
      let notProsList: RequirementColumn[] = [];
      let flatBomList: RequirementColumn[] = []

      for (let i = 0; i < resInitData.length; i++) {
        if (!!!productListMap[resInitData[i].product.code]) notProsList.push(resInitData[i])
        else flatBomList.push({
          ...resInitData[i],
          bomItemId: productListMap[resInitData[i].product.code].id,
          product: {
            ...productListMap[resInitData[i].product.code]
          }
        })
      }

      if (notProsList.length > 0) {
        setAddNewPros([...notProsList])
        setInitBomData([...flatBomList])
        setBomLoading(false);
        return
      } else handleFlatData([...flatBomList]);

    } catch (error) {
    } finally { setBomLoading(false) }
  };

  const handleFlatData = (flatData: Array<RequirementColumn>) => {
    let xlsParse = [...makeBomData(flatData)];
    if (xlsParse.length === 0) {
      notification.error({ message: t('requirement.dataTypeErr'), description: t('requirement.dataTypeErrTip') });
      if (templeData.length) setDataType("T")
      else if (bomData.length) setDataType("B")
    } else setXlsData(xlsParse);
  };
  const handleAddNewPros = async () => {
    setAddProsLoaidng(true);
    setAddProsProgress(0)
    let newDatas: RequirementColumn[] = [];
    try {
      for (let i = 0; i < addNewPros.length; i++) {
        try {
          let product = await productAdd({
            code: addNewPros[i].product.code,
            name: addNewPros[i].product.name,
            process: addNewPros[i].product.process,
            model: addNewPros[i].product.model,
            uom: addNewPros[i].product.uom,
            deprecated: null
          })
          newDatas.push({
            ...addNewPros[i],
            bomItemId: product.id,
            product
          })
        } catch (error: any) {
          if (error !== 70603) throw (error)
        }
        setAddProsProgress(Math.round((i + 1) / addNewPros.length * 100))
      }
      setAddNewPros([]);
      setAddProsLoaidng(false);
      handleFlatData([...initBomData, ...newDatas]);
    } catch (error) {
      notification.error({ message: t('common.addError') })
      setAddProsLoaidng(false)
    }

  }
  const handleCancelAddPros = () => {
    notification.info(
      {
        message: t('common.tip'),
        description: (
          <>
            <div>{t('bom.notItem')}</div>
            <div>{addNewPros.map(a => a.product.code).join(', ')}</div>
          </>
        )
      }
    )
    setAddNewPros([]);
    handleFlatData([...initBomData])
  }

  const columns: ColumnsType<RequirementColumn> = [
    {
      title: <SText text={t("product.code")} />,
      dataIndex: ["product", "code"],
      width: 100,
      sorter: (a, b) => {
        const valA = a?.product?.code ?? "";
        const valB = b?.product?.code ?? "";
        return valA.localeCompare(valB);
      },
      render: (_, item) => <SText text={item?.product?.code ?? ''} style={{ width: "100%" }} />,
    },
    {
      title: <SText text={t("product.name")} />,
      dataIndex: "name",
      width: 100,
      render: (_, item) => <SText text={item?.product?.name ?? ''} style={{ width: "100%" }} />,
    },
    {
      title: <SText text={t("counting.productModal")} />,
      dataIndex: "model1",
      width: 120,
      render: (_, item) => <SText text={item?.product?.model ?? ''} style={{ width: "100%" }} />,
    },
    {
      title: <SText text={t("product.uom")} />,
      dataIndex: "uom",
      width: 80,
      render: (_, item) => <SText text={item?.product?.uom ?? ''} style={{ width: "100%" }} />,
    },
    {
      title: <SText text={t("product.process")} />,
      dataIndex: "process",
      width: 120,
      render: (_, item) => <SText text={item?.product?.process ?? ''} style={{ width: "100%" }} />,
    },
  ]

  return (
    <ModalWrap
      centered
      title={t("requirement.requirementCreate")}
      width="100vw"
      height="100vh"
      footer={null}
      onCancel={() => {
        if (current === steps.length - 1) {
          if (!!failAdd && !!failItems.length) {
            modal.confirm({
              title: t('requirement.failPreTip'),
              content: t('requirement.failPreTipDesc'),
              onOk: () => handleCancel()
            })
          } else handleCancel()
        } else modal.confirm({
          title: t('common.tip'),
          content: t('bom.closeTip'),
          onOk: () => handleCancel()
        })
      }}
      {...modalProps}
    >
      <CreateHeader
        current={current}
        requirementCount={requirementCount}
        setRequirementCount={setRequirementCount}
        item={item}
      />
      <Steps current={current} items={steps} />
      <div className="step-content" ref={scrollContainerRef}>
        {
          deLoading || bomLoading ? <Flex justify="center" align="center" className="spin-container" ><Spin /></Flex>
            : steps[current].content
        }
      </div>
      {current !== steps.length - 1 && <CreateFooter prodInputRef={prodInputRef} saleOrder={saleOrder}
        preOutDesc={desc}
        preOutLocationTypes={preOutLocationTypes}
        locTypes={locTypes}
        isTemp={isTemp}
        item={item}
        detail={detail}
        bomSubs={bomSubs}
        purchaseProducts={purchaseProducts}
        setPurchaseProducts={setPurchaseProducts}
        matchedProducts={matchedProducts}
        setMatchedProducts={setMatchedProducts}
        confirmProducts={confirmProducts}
        setConfirmProducts={setConfirmProducts}
        formData={formData}
        setFormData={setFormData}
        steps={steps}
        handleAdd={handleAdd}
        setNumber={setNumber}
        current={current}
        setCurrent={setCurrent}
        requireCount={requirementCount}
        disNext={disNext}
        setDisNext={() => setDisNext(false)}
        matchStock={matchStock}
        setMatchStock={() => setMatchStock(false)}
        isMerge={isMerge}
        setFailItems={setFailItems}
        setFailAdd={setFailAdd}
      />}
      {
        addNewPros.length > 0 && (
          <Modal title={t('product.addProduct')}
            onOk={handleAddNewPros}
            onCancel={handleCancelAddPros}
            okButtonProps={{ loading: addProsLoaidng }}
            maskClosable={false}
            width={1200}
            open={true}
          >
            <Flex vertical style={{ width: "100%", height: "50vh" }}>
              <STableLayout
                headerChildren={
                  <Typography.Title level={4} style={{ margin: 0 }}>
                    {t('bom.addTip')}
                  </Typography.Title>
                }
                columns={columns as Array<AnyObject>}
                dataSource={addNewPros}
                total={addNewPros.length}
                pagination={false}
                extHeight={70}
              />
            </Flex>
          </Modal>
        )
      }
      {
        addProsLoaidng && <ExportProgressModal
          visible={addProsLoaidng}
          progress={addProsProgress}
          title={t('product.addProduct')}
          processLabel={t('product.addProduct')}
        />
      }
    </ModalWrap>
  );
};

export default CreateRequirement;
